module.exports = __webpack_public_path__ + "static/media/ico-hfeatured-arrow-right.c51d7333.svg";